
import { actionTypes, CreateQuestionInput, QuationProps, UpdateQuestionInput } from './actionType';
import { executeMutation, executeQuery } from 'utils/services/apiServices';
import { FETCH_QUESTIONS_BY_VIDEO_ID } from '../graphql/query';
import { CREATE_QUESTION_WITH_OPTION, DELETE_QUESTION_WITH_OPTION, UPDATE_QUESTION_PUBLISED_STATUS, UPDATE_QUESTION_WITH_OPTION } from '../graphql/mutation';
import { showSnackbar } from 'utils/snack_bar/store/action';

export const fetchQuestionsRequest = () => ({
    type: actionTypes.FETCH_QUESTIONS_REQUEST
});

export const fetchQuestionsSuccess = (payload: QuationProps[]) => ({
    type: actionTypes.FETCH_QUESTIONS_SUCCESS,
    payload
});

export const fetchQuestionsFail = (payload: string) => ({
    type: actionTypes.FETCH_QUESTIONS_FAIL,
    payload
});

export const fetchQuestions = (video_id:string) => {
    return async (dispatch: any) => {
        try {
            const input = {
                video_id: video_id
            };
            await dispatch(fetchQuestionsRequest());
            const response = await executeQuery(FETCH_QUESTIONS_BY_VIDEO_ID,input);
            const jsonData = response.data?.fetchQuestionsByVideoId;
            if (jsonData?.error === null) {
                dispatch(fetchQuestionsSuccess(jsonData?.data.questions));
            } else {
                dispatch(fetchQuestionsFail(jsonData?.error.message));
            }
        } catch (error: any) {
            dispatch(fetchQuestionsFail('Failed to fetch Questions'));
        }
    };
};

//Create question
export const createQuestionsRequest= () => ({
    type: actionTypes.CREATE_QUESTION_REQUEST
});
export const createQuestionsSuccess= (payload: QuationProps[]) => ({
    type: actionTypes.CREATE_QUESTION_SUCCESS,
    payload
});
export const createQuestionsFail= (payload: string) => ({
    type: actionTypes.CREATE_QUESTION_FAIL,
    payload
});
export const createQuestions = (input: CreateQuestionInput) => {
    return async (dispatch: any) => {
        try {
             const inputData = {
                input:input
            }
            dispatch(createQuestionsRequest())
            const response = await executeMutation(CREATE_QUESTION_WITH_OPTION, inputData);
            const jsonData = response.data?.createQuestionWithOption;
            if (jsonData?.error === null) {
                dispatch(createQuestionsSuccess(jsonData?.data.questions));
                 dispatch(showSnackbar('Success! Q and A created.'));
            } else {
                dispatch(createQuestionsFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(createQuestionsFail('Something went wrong, Try again later'))
        }
    };
};

//Update question
export const updateQuestionsRequest= () => ({
    type: actionTypes.UPDATE_QUESTION_REQUEST
});
export const updateQuestionsSuccess= (payload: QuationProps) => ({
    type: actionTypes.UPDATE_QUESTION_SUCCESS,
    payload
});
export const updateQuestionsFail= (payload: string) => ({
    type: actionTypes.UPDATE_QUESTION_FAIL,
    payload
});
export const updateQuestions = ( questionId: string, input: UpdateQuestionInput, ) => {
    return async (dispatch: any) => {
        try {
             const variables = {
        questionId: questionId,
        input: input
      };
            dispatch(updateQuestionsRequest())
            const response = await executeMutation(UPDATE_QUESTION_WITH_OPTION, variables);
            const jsonData = response.data?.UpdateQuestionWithOption;
            if (jsonData?.error === null) {
                dispatch(updateQuestionsSuccess(jsonData?.data.question));
                 dispatch(showSnackbar('Success! Q and A updated.'));
            } else {
                dispatch(updateQuestionsFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(updateQuestionsFail('Something went wrong, Try again later'))
        }
    };
};

//Update question published status
export const updateQuestionStatusRequest= () => ({
    type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_REQUEST
});
export const updateQuestionStatusSuccess= (payload: QuationProps) => ({
    type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_SUCCESS,
    payload
});
export const updateQuestionStatusFail= (payload: string) => ({
    type: actionTypes.UPDATE_QUESTION_PUBLISED_STATUS_FAIL,
    payload
});
export const updateQuestionStatus = (questionId: string, isPublished: boolean ) => {
   return async (dispatch: any) => {
        try {
             const inputData = {
                questionId:questionId,
                isPublished: isPublished
            }
            dispatch(updateQuestionStatusRequest())
            const response = await executeMutation(UPDATE_QUESTION_PUBLISED_STATUS, inputData);
            const jsonData = response.data?.UpdateQuestionPublishedStatus;
            if (jsonData?.error === null) {
                dispatch(updateQuestionStatusSuccess(jsonData?.data.question));
                 dispatch(showSnackbar('Success! Status updated.'));
            } else {
                dispatch(updateQuestionStatusFail(jsonData?.error.message))
                 dispatch(showSnackbar(`Fail to update. Error: ${jsonData?.error.message || "Something went wrong"}`));
            }
        } catch (error: any) {
            dispatch(updateQuestionStatusFail('Something went wrong, Try again later'))
        }
    };
};

//Delete question
export const deleteQuestionsRequest= () => ({
    type: actionTypes.DELETE_QUESTION_REQUEST
});
export const deleteQuestionsSuccess= (payload: string) => ({
    type: actionTypes.DELETE_QUESTION_SUCCESS,
    payload
});
export const deleteQuestionsFail= (payload: string) => ({
    type: actionTypes.DELETE_QUESTION_FAIL,
    payload
});
export const deleteQuestions = (questionId: string) => {
    return async (dispatch: any) => {
        try {
             const inputData = {
                questionId:questionId
            }
            dispatch(deleteQuestionsRequest())
            const response = await executeMutation(DELETE_QUESTION_WITH_OPTION, inputData);
            const jsonData = response.data?.deleteQuestionWithOption;
            if (jsonData?.error === null) {
                dispatch(deleteQuestionsSuccess(questionId));
                 dispatch(showSnackbar('Success! Q and A deleted.'));
            } else {
                dispatch(deleteQuestionsFail(jsonData?.error.message))
                dispatch(showSnackbar(`Error :${jsonData?.error.message ? jsonData?.error.message : "Something went wrong"}`))
            }
        } catch (error: any) {
            dispatch(deleteQuestionsFail('Something went wrong, Try again later'))
        }
    };
};
